import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type Group = 'staff' | 'costco' | 'directSmallBusiness' | 'velocity' | 'thriday';

export interface AppDetailsState {
  groups: Group[];
  userEmail?: string;
  channel: Group;
  spaId?: string;
  /** Set when initialized. Can be used by child components to do initialization. */
  isInitialized: boolean;
}

export const appDetailsSlice = createSlice({
  name: 'appDetails',
  initialState: {
    groups: ['directSmallBusiness'],
    channel: 'directSmallBusiness',
    isInitialized: false,
  } as AppDetailsState,
  reducers: {
    updateGroups: (state, { payload }: PayloadAction<string[]>) => {
      state.groups = payload as Group[];
    },
    addGroup: (state, { payload }: PayloadAction<Group>) => {
      if (!state.groups.includes(payload)) state.groups.push(payload);
    },
    updateUserEmail: (state, { payload }: PayloadAction<string | undefined>) => {
      state.userEmail = payload;
    },
    updateChannel: (state, { payload }: PayloadAction<Group>) => {
      state.channel = payload;
    },
    updateSpaId: (state, { payload }: PayloadAction<string | undefined>) => {
      state.spaId = payload;
    },
    setInitialized: (state) => {
      state.isInitialized = true;
    },
  },
});

export const { updateGroups, addGroup, updateUserEmail, setInitialized, updateSpaId } =
  appDetailsSlice.actions;
